<mat-icon
  class="blocked-icon"
  svgIcon="blocked-icon"
  [matTooltip]="text"
  matTooltipPosition="above"
  matTooltipClass="info-tooltip"></mat-icon>
